import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { NoticePopup } from '@/store/API/PopupAcknowledgements'
import { parseContentWithMultipleFML } from '../utils/fmlToken'
import MessageCardWithFml from './MessageCardWithFml.vue'
import MessageCardWithoutFml from './MessageCardWithoutFml.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageCard',
  props: {
    message: null,
    doNotSubmitFml: { type: Boolean }
  },
  emits: ["acknowledge", "close", "snooze"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'acknowledge'): void;
	(e: 'close'): void;
	(e: 'snooze'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	message: NoticePopup;
	doNotSubmitFml?: boolean;
}





const parsedContent = computed(() => parseContentWithMultipleFML(props.message.content))

const acknowledgeAndClose = () => {
	emit('acknowledge')
	emit('close')
}

const snoozeAndClose = () => {
	emit('snooze')
	emit('close')
}

return { __sfc: true,props, emit, parsedContent, acknowledgeAndClose, snoozeAndClose, MessageCardWithFml, MessageCardWithoutFml }
}

})